export default "__VITE_ASSET__CwqUpPqg__"